import apiClient from '@lib/apiClient';
import { DeleteSystemAgentPackageRequest, DeployPackageToAllSystemsRequest, DeployPackageToAllSystemsResponse, DeployPackageToSystemsRequest, DeployPackageToSystemsResponse, GetSystemsWithAgentVersionsRequest, GetSystemsWithAgentVersionsResponse, ListSystemAgentPackagesResponse, SystemAgentPackage, UploadSystemAgentPackageRequest } from '@features/deployment/domain/packages.types';

const API_BASE_URL = '/deployment/packages';

export const packageService = {
  listPackages: async (): Promise<ListSystemAgentPackagesResponse> => {
    const response = await apiClient.get<ListSystemAgentPackagesResponse>(API_BASE_URL);
    return response.data;
  },

  uploadPackage: async (request: UploadSystemAgentPackageRequest): Promise<SystemAgentPackage> => {
    const formData = new FormData();
    formData.append('file', request.file);

    const params: Record<string, string> = {
      version: request.version
    };
    if (request.description) {
      params.description = request.description;
    }

    const response = await apiClient.post<SystemAgentPackage>(
      API_BASE_URL,
      formData,
      {params}
    );
    return response.data;
  },

  deletePackage: async (request: DeleteSystemAgentPackageRequest): Promise<void> => {
    await apiClient.delete(`${API_BASE_URL}/${request.packageId}`);
  },

  getSystemsWithAgentVersions: async (request: GetSystemsWithAgentVersionsRequest): Promise<GetSystemsWithAgentVersionsResponse> => {
    const response = await apiClient.get<GetSystemsWithAgentVersionsResponse>(
      '/deployment/systems/agent-versions/batch',
      {
        params: {systemIds: request.systemIds},
        paramsSerializer: {indexes: null}
      }
    );
    return response.data;
  },

  deployPackageToSystems: async (request: DeployPackageToSystemsRequest): Promise<DeployPackageToSystemsResponse> => {
    const response = await apiClient.post<DeployPackageToSystemsResponse>('/deployment/deploy-package', request);
    return response.data;
  },

  deployPackageToAllSystems: async (request: DeployPackageToAllSystemsRequest): Promise<DeployPackageToAllSystemsResponse> => {
    const response = await apiClient.post<DeployPackageToAllSystemsResponse>('/deployment/deploy-package-to-all', request);
    return response.data;
  }
};